import { FormType } from '../../../form-types';
import { wlusmonthly_2024 } from '../monthly/archived/flow';

// ONLY for products that are branded IE Ozempic and Wegovy
export const wlusFollowupBranded: FormType = {
  name: 'Branded Weight Loss Followup',
  questions: wlusmonthly_2024.questions
};
